import React from 'react';
import {
  Route,
  Routes,
} from 'react-router-dom'


import MainLayout from 'src/layouts/MainLayout';

import HomePage from 'src/front_site/home/HomePage'
import PrivacyPolicyPage from 'src/front_site/privacy_policy/PrivacyPolicyPage';
import TermsConditionsPage from 'src/front_site/tems_conditions/TermsConditionsPage';
import ContactUsPage from 'src/front_site/contact_us/ContactUsPage';
import BOMToolPage from './bom_tool/BOMToolPage';
import PricingPage from './pricing/PricingPage';
import ResetPasswordPage from './sessions/ResetPasswordPage';
import JoinTeamPage from '../account/team/JoinTeamPage';


export default (
  <Routes>
    <Route path="/" element={<MainLayout />}>
      <Route index element={<HomePage />} />
      <Route path="pricing" element={<PricingPage />} />
      <Route path="login" element={<HomePage />} />
      <Route path="signup" element={<HomePage />} />
      <Route path="bom-tool" element={<BOMToolPage />} />
      <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="terms-and-conditions" element={<TermsConditionsPage />} />
      <Route path="contact-us" element={<ContactUsPage />} />
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route path="join-team" element={<JoinTeamPage />} />
    </Route>
  </Routes>
)